/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon32Regular = forwardRef('ArrowRoundTimeBackIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10.882 6.263a11 11 0 1 1-4.956 14.156 1 1 0 1 0-1.831.803A13 13 0 1 0 5 9.072V5a1 1 0 1 0-2 0v6.5A1.5 1.5 0 0 0 4.5 13h6a1 1 0 1 0 0-2H6.202a11 11 0 0 1 4.68-4.737Z" })));
});
